import Loading from "@@/core/components/shared/Loading/Loading";
import ExperimentFiles from "@@/core/components/experiment/ExperimentFiles/ExperimentFiles";
import {
  BTooltip,
  BButton,
  BCard,
  BTable,
  BCollapse,
  BFormGroup,
  BFormInput,
  VBModal,
  BModal,
  BFormSelect,
  BForm,
  VBToggle,
  BFormTextarea,
  BFormCheckbox,
} from "bootstrap-vue";
export default {
  name: "Products",
  components: {
    Loading,
    BTooltip,
    BButton,
    BCard,
    BTable,
    BCollapse,
    BFormGroup,
    BFormInput,
    BModal,
    BFormSelect,
    BForm,
    ExperimentFiles,
    BFormTextarea,
    BFormCheckbox,
  },
  directives: {
    "b-modal": VBModal,
    "b-toggle": VBToggle,
  },
  data() {
    return {
      id: null,
      item: {},
      editForm: {
        description: "",
        admin_description: "",
        receive_datetime: "",
        status: "new",
      },
      resultForm: {
        result_description: "",
        done_at: "",
        result: 0,
        deleted_files_id: [],
        result_files: [],
      },
      disabled: false,
      statusOptions: [
        {
          value: "canceled",
          text: "لغو شده",
        },
        {
          value: "new",
          text: "جدید",
        },
        {
          value: "done",
          text: "انجام شده",
        },
        {
          value: "received",
          text: "دریافت شده",
        },
      ],
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.loadData(this.$route.params.id);
    }
  },
  methods: {
    async loadData(id) {
      await this.$axios
        .get(`admin/experiments/${id}`)
        .then((res) => {
          this.item = res.data.data.experiment;
          this.editForm = {
            description: this.item.description,
            admin_description: this.item.admin_description,
            receive_datetime: this.item.receive_datetime,
            status: this.item.status,
          };
          this.resultForm = {
            result_description: this.item.result_description,
            done_at: this.item.done_at,
            result: this.item.result,
            deleted_files_id: [],
            result_files: [],
          };
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async submitExperimentEdit() {
      this.disabled = true;
      let formData = new FormData();
      formData.append("admin_description", this.editForm.admin_description);
      formData.append("status", this.editForm.status);
      formData.append("receive_datetime", this.editForm.receive_datetime);
      formData.append("description", this.editForm.description);
      formData.append("_method", "PUT");
      await this.$axios
        .post(`admin/experiments/${this.id}`, formData)
        .then((res) => {
          this.$root.notify(res.data.message, "success");
          this.$root.$emit("bv::hide::modal", "edit-experiment-detail");
          this.editForm = {
            description: res.data.data.experiment.description,
            admin_description: res.data.data.experiment.admin_description,
            receive_datetime: res.data.data.experiment.receive_datetime,
            status: res.data.data.experiment.status,
          };
          this.$forceUpdate();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
    deletedFilesId(values) {
      console.log(values);
      this.resultForm.deleted_files_id = values;
    },
    newFiles(values) {
      this.resultForm.result_files = values;
    },
    async submitExperimentResult() {
      this.disabled = true;
      let fd = new FormData();
      for (const key in this.resultForm) {
        if (key == "result_files") {
          this.resultForm[key].forEach((file, index) => {
            fd.append(`result_files[${index}]`, file);
          });
        } else {
          fd.append(key, this.resultForm[key]);
        }
      }
      await this.$axios
        .post(`admin/experiments/${this.id}/store_result`, fd)
        .then((res) => {
          this.$root.notify(res.data.message, "success");
          this.$root.$emit("bv::hide::modal", "edit-experiment-result");
          this.editForm = {
            description: res.data.data.experiment.description,
            admin_description: res.data.data.experiment.admin_description,
            receive_datetime: res.data.data.experiment.receive_datetime,
            status: res.data.data.experiment.status,
          };
          this.$forceUpdate();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
    getStatusColor(status) {
      switch (status) {
        case "canceled":
          return "#dc3545";
        case "new":
          return "#0d6efd";
        case "done":
          return "#0fbb6b";
        case "received":
          return "#0dcaf0";
      }
    },
    getStatus(status) {
      switch (status) {
        case "canceled":
          return "کنسل شده";
        case "new":
          return "جدید";
        case "done":
          return "کامل شده";
        case "received":
          return "دریافت شده";
      }
    },
  },
};
